<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button" class="active">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'OrderList' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li v-if="local != 'jp' && IsTester">
            <router-link :to="{ name: 'MemberCoupon' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("優惠專區") }}
            </router-link>
          </li>
          <li v-if="local != 'jp' && IsTester && hasInvite">
            <router-link :to="{ name: 'InvitEvent' }" tag="button">
              <img src="img/member_icon_friends.svg" alt="" />
              {{ $t("邀請朋友") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main" v-if="UserData.User">
          <div class="bg-box">
            <h1>{{ $t("會員資料") }}</h1>
            <hr />
            <ul class="text-box">
              <li>
                <div>{{ $t("帳號") }}</div>
                <div>{{ UserData.User.Account }}</div>
              </li>
              <li v-if="!UserData.User.IsOAuth">
                <div>{{ $t("手機號碼") }}</div>
                <div v-if="UserData.User.Phone">{{ hideInfo(UserData.User.Phone, 7, 3) }}</div>
                <div v-else>未設定</div>
              </li>
              <li v-if="UserData.CInfoData != null">
                <div>{{ $t("姓名") }}</div>
                <div>{{ hideInfo(UserData.CInfoData.o_maas_cinfo_name, 1, 1) }}</div>
              </li>
              <li v-if="UserData.CInfoData != null">
                <div>{{ $t("性別") }}</div>
                <div>{{ UserData.CInfoData.o_maas_cinfo_gender }}</div>
              </li>
              <li v-if="UserData.CInfoData != null &&
                UserData.CInfoData.o_maas_cinfo_birth != ''
              ">
                <div>{{ $t("出生年月") }}</div>
                <div>{{ UserData.CInfoData.o_maas_cinfo_birth }}</div>
              </li>
              <li v-if="UserData.CInfoData != null">
                <div>{{ $t("國籍") }}</div>
                <div>{{ UserData.CInfoData.o_maas_cinfo_nation }}</div>
              </li>
              <!-- <li v-if="UserData.CInfoData != null">
                <div>{{ $t("MeN Go卡號") }}</div>
                <div>{{ UserData.CInfoData.o_maas_cinfo_name }}</div>
              </li>
              <li v-if="UserData.CInfoData != null">
                <div>{{ $t("MeN Go卡狀態") }}</div>
                <div>{{ UserData.CInfoData.o_maas_cinfo_name }}</div>
              </li> -->
              <hr v-if="!UserData.User.IsOAuth" />
              <li v-if="!UserData.User.IsOAuth">
                <div>{{ $t("更換手機號碼") }}</div>
                <div class="phone-change box" style="position: relative">
                  <div class="phone">
                    <vue-tel-input v-bind="vtiProps" @input="onInput"></vue-tel-input>
                  </div>
                  <div class="code-box box" v-if="!issned">
                    <button class="get-code" @click="getPinCode">
                      {{ $t("獲取驗證碼") }}
                    </button>
                  </div>
                  <span id="showPhone" @click="viewphone = !viewphone"><img
                      :src="viewphone ? 'img/eyes-n.png' : 'img/eyes-y.png'" style="width: auto; height: 16px" /></span>
                </div>
              </li>
              <li v-if="issned">
                <div>
                  <label for="newPasswordConfirm">{{ $t("手機認證碼") }}</label>
                </div>
                <div class="password-change box">
                  <input :placeholder="$t('請輸入手機簡訊認證碼')" type="text" class="form-control" id="inputCode"
                    v-model="pincode_input" />
                  <button class="" @click="handleChangePhone">
                    {{ $t("確認更換手機號碼") }}
                  </button>
                </div>
              </li>
              <hr />
              <li v-if="!UserData.User.IsOAuth && !issned">
                <div>
                  <label for="password">{{ $t("舊密碼") }}</label>
                </div>
                <div>
                  <input :placeholder="$t('請輸入舊密碼')" type="password" class="form-control" id="password"
                    v-model="password" maxlength="25" />
                </div>
              </li>
              <li v-if="!UserData.User.IsOAuth && !issned">
                <div>
                  <label for="newPassword">{{ $t("新密碼") }}</label>
                </div>
                <div>
                  <input :placeholder="$t('請輸入新密碼')" type="password" class="form-control" id="newPassword"
                    v-model="newPassword" maxlength="25" />
                </div>
              </li>
              <li v-if="!UserData.User.IsOAuth && !issned">
                <div>
                  <label for="newPasswordConfirm">{{ $t("確認密碼") }}</label>
                </div>
                <div class="password-change box">
                  <input :placeholder="$t('確認密碼')" type="password" class="form-control" id="newPasswordConfirm"
                    v-model="newPasswordConfirm" maxlength="25" />
                  <button class="" @click="handleChangePassword">
                    {{ $t("更改密碼") }}
                  </button>
                </div>
              </li>
              <hr v-if="!UserData.User.IsOAuth && !issned" />
              <li>
                <div>
                  <label for="city">{{ $t("縣市") }}</label>
                </div>
                <div>
                  <select class="form-control" id="city">
                    <option v-for="City in UserData.Citys" :key="City.o_maas_city_seq" :value="City.o_maas_city_seq">
                      {{
                        local == "en"
                          ? City.o_maas_city_name_en
                          : City.o_maas_city_name_zh_tw
                      }}
                    </option>
                  </select>
                </div>
              </li>
              <li>
                <div>
                  <label for="town">{{ $t("鄉鎮區") }}</label>
                </div>
                <div>
                  <select class="form-control" id="town">
                    <option v-for="Town in UserData.Towns" :key="Town.o_maas_town_seq" :value="Town.o_maas_town_seq">
                      {{
                        local == "en"
                          ? Town.o_maas_town_name_en
                          : Town.o_maas_town_name_zh_tw
                      }}
                    </option>
                  </select>
                </div>
              </li>
              <li style="display: none">
                <div>
                  <label for="address">{{ $t("地址") }}</label>
                </div>
                <div>
                  <input :placeholder="$t('請輸入地址(選填)')" type="text" class="form-control" id="address"
                    v-model="address" />
                </div>
              </li>
              <li>
                <div>
                  <label for="city">{{ $t("專案合作單位") }}</label>
                </div>
                <div>
                  <select class="form-control" id="CUId" v-model="CUId">
                    <option value="-1">
                      {{ $t("請選擇(選填)") }}
                    </option>
                    <option v-for="CooperationUnit in UserData.CooperationUnits" :key="CooperationUnit.CUId"
                      :value="CooperationUnit.CUId">
                      {{
                        CooperationUnit.Name
                      }}
                    </option>
                  </select>
                </div>
              </li>
              <li>
                <div>
                  <label for="taxID">{{ $t("統一編號") }}</label>
                </div>
                <div>
                  <input :placeholder="$t('請輸入統一編號(選填)')" type="text" class="form-control" id="taxID" v-model="taxID"
                    maxlength="20" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
                </div>
              </li>
              <li>
                <div>
                  <label for="taxID">{{ $t("職工編號") }}</label>
                </div>
                <div>
                  <input :placeholder="$t('請輸入職工編號(選填)')" type="text" class="form-control" id="unitId" v-model="unitId"
                    maxlength="50" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
                </div>
              </li>
              <li>
                <div>
                  <label for="school">{{ $t("學校名稱") }}</label>
                </div>
                <div style="width: 190px;">
                  <!-- <input :placeholder="$t('請輸入學校名稱(選填)')" type="text" class="form-control" id="school" v-model="school"
                    maxlength="50" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" /> -->
                  <!-- <select2 v-model="school" :options="SchoolCitys" :settings="{ placeholder: '請選擇', language: 'zh-TW', allowClear: true }" style="width: 100%; margin-right: 0;" /> -->
                  <select v-select2="{ placeholder: '請直接輸入關鍵字', value: school }" v-model="school">
                    <option value="">無</option>
                    <optgroup v-for="(SchoolCity, index) in UserData.SchoolCitys" :label="SchoolCity.City">
                      <option v-for="(School, idx) in SchoolCity.Schools" :value="School.Name">{{ School.Name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
              </li>
              <li style="position: relative">
                <div>
                  <label for="email">{{ $t("電子信箱") }}</label>
                </div>
                <div>
                  <input :placeholder="$t('請輸入電子信箱(選填)')" :type="viewemail ? 'text' : 'password'" class="form-control"
                    id="email" v-model="email" maxlength="100" autocomplete="off" autocorrect="off" autocapitalize="off"
                    spellcheck="false" />
                  <span id="showEmail" @click="viewemail = !viewemail"><img
                      :src="viewemail ? 'img/eyes-n.png' : 'img/eyes-y.png'" style="width: auto; height: 16px" /></span>
                </div>
              </li>
              <li>
                <div>
                  <label for="gender">{{ $t("性別") }}</label>
                </div>
                <div class="password-change box">
                  <select class="form-control" id="gender" v-model="gender">
                    <option value="" selected>{{ $t("未設定") }}</option>
                    <option value="M">{{ $t("男性") }}</option>
                    <option value="F">{{ $t("女性") }}</option>
                  </select>
                  <button class="" @click="handleChangeInfo">
                    {{ $t("更新資訊") }}
                  </button>
                </div>
              </li>
              <hr />
              <li>
                <div>{{ $t("登出此帳號") }}</div>
                <div class="box">
                  <button class="change-btn" @click="logout">
                    {{ $t("登出") }}
                  </button>
                </div>
              </li>
              <li>
                <div>{{ $t("註銷帳號") }}</div>
                <div class="box">
                  <button class="change-btn" @click="applyClear">
                    {{ $t("申請註銷此帳號") }}
                  </button>
                </div>
              </li>
              <hr />
              <li>
                <div>Ver.</div>
                <div>{{ GLOBAL.localVer }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueTelInput, {
  autoDefaultCountry: true,
  defaultCountry: 886,
  dropdownOptions: {
    showDialCodeInSelection: true,
  },
  inputOptions: {
    placeholder: "",
  },
});
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    "會員資料": "會員資料",
    "我的套票": "我的套票",
    "卡片資料": "卡片資料",
    "套票兌換": "套票兌換",
    "交易記錄": "交易記錄",
    "其他資訊": "其他資訊",
    "帳號": "帳號",
    "手機號碼": "手機號碼",
    "姓名": "姓名",
    "性別": "性別",
    "出生年月": "出生年月",
    "國籍": "國籍",
    "更換手機號碼": "更換手機號碼",
    "獲取驗證碼": "獲取驗證碼",
    "手機認證碼": "手機認證碼",
    "請輸入手機簡訊驗證碼": "請輸入手機簡訊驗證碼",
    "確認更換手機號碼": "確認更換手機號碼",
    "舊密碼": "舊密碼",
    "請輸入舊密碼": "請輸入舊密碼",
    "新密碼": "新密碼",
    "請輸入新密碼": "請輸入新密碼",
    "確認密碼": "確認密碼",
    "更改密碼": "更改密碼",
    "登出此帳號": "登出此帳號",
    "登出": "登出",
    "錯誤": "錯誤",
    "取得會員資訊過程發生錯誤, 請稍後再試一次": "取得會員資訊過程發生錯誤, 請稍後再試一次",
    "確定": "確定",
    "手機號碼格式錯誤": "手機號碼格式錯誤",
    "更換手機號碼成功，請使用新的手機號碼重新登入": "更換手機號碼成功，請使用新的手機號碼重新登入",
    "重設密碼與確認重設密碼不符合, 請確認後再試一次": "重設密碼與確認重設密碼不符合, 請確認後再試一次",
    "重設密碼成功": "重設密碼成功",
    "註銷此帳號": "註銷此帳號",
    "申請註銷此帳號": "申請註銷此帳號",
    "請注意！一旦註銷帳號，即無法再恢復帳號資料，並且您原綁定的卡片號碼未來亦無法重複於MeN Go系統上綁定使用，如有其他因素確認欲註銷帳號，請電洽客服專線由專人協助。本人已充分瞭解並同意承擔其後果，請輸入DELETE後按下送出。": "請注意！一旦註銷帳號，即無法再恢復帳號資料，並且您原綁定的卡片號碼未來亦無法重複於MeN Go系統上綁定使用，如有其他因素確認欲註銷帳號，請電洽客服專線由專人協助。本人已充分瞭解並同意承擔其後果，請輸入DELETE後按下送出。",
    "送出": "送出",
    "取消": "取消",
    "請輸入DELETE後再按下送出": "請輸入DELETE後再按下送出",
    "帳號註銷成功": "帳號註銷成功",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
    "縣市": "縣市",
    "鄉鎮區": "鄉鎮區",
    "地址": "地址",
    "請輸入地址(選填)": "請輸入地址(選填)",
    "統一編號": "統一編號",
    "請輸入統一編號(選填)": "請輸入統一編號(選填)",
    "學校名稱": "學校名稱",
    "請輸入學校名稱(選填)": "請輸入學校名稱(選填)",
    "電子信箱": "電子信箱",
    "請輸入電子信箱(選填)": "請輸入電子信箱(選填)",
    "更新資訊": "更新資訊",
    "註銷帳號": "註銷帳號",
    "專案合作單位": "專案合作單位",
    "請選擇(選填)": "請選擇(選填)",
    "職工編號": "職工編號",
    "請輸入職工編號(選填)": "請輸入職工編號(選填)",
  },
  en: {
    "會員資料": "Member info",
    "我的套票": "My pass",
    "卡片資料": "Card info",
    "套票兌換": "Redeem pass",
    "交易記錄": "Card record",
    "其他資訊": "Other info",
    "帳號": "Account ",
    "手機號碼": "Mobile number",
    "姓名": "Name",
    "性別": "Gender",
    "出生年月": "Date of birth",
    "國籍": "Nationality",
    "更換手機號碼": "Change the mobile number",
    "獲取驗證碼": "Get the verification code",
    "手機認證碼": "Mobile verification code",
    "請輸入手機簡訊驗證碼": "Please enter the verification code",
    "確認更換手機號碼": "Confirm to change the mobile number",
    "舊密碼": "Old password",
    "請輸入舊密碼": "Please enter the old password",
    "新密碼": "New password",
    "請輸入新密碼": "Please enter the new password",
    "確認密碼": "Confirm the password",
    "更改密碼": "Change the password",
    "登出此帳號": "Log out the account",
    "登出": "Log out",
    "錯誤": "Error",
    "取得會員資訊過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "確定": "Confirm",
    "手機號碼格式錯誤": "Wrong mobile number format",
    "更換手機號碼成功，請使用新的手機號碼重新登入": "Done. Please use the new mobile number to log in.",
    "重設密碼與確認重設密碼不符合, 請確認後再試一次": "Please confirm the new password and try again.",
    "重設密碼成功": "Password reset",
    "註銷此帳號": "Delete Account",
    "申請註銷此帳號": "Apply",
    "請注意！一旦註銷帳號，即無法再恢復帳號資料，並且您原綁定的卡片號碼未來亦無法重複於MeN Go系統上綁定使用，如有其他因素確認欲註銷帳號，請電洽客服專線由專人協助。本人已充分瞭解並同意承擔其後果，請輸入DELETE後按下送出。": "請注意！一旦註銷帳號，即無法再恢復帳號資料，並且您原綁定的卡片號碼未來亦無法重複於MeN Go系統上綁定使用，如有其他因素確認欲註銷帳號，請電洽客服專線由專人協助。<br /><br /><span style=\"color: red;\">本人已充分瞭解並同意承擔其後果<br />請輸入 <span style=\"color: blue;\">DELETE</span> 後按下送出。</span>",
    "送出": "Submit",
    "取消": "Cancel",
    "請輸入DELETE後再按下送出": "Please enter \"DELETE\" and submit.",
    "帳號註銷成功": "Account deleted success",
    "卡片交易紀錄": "Activity",
    "減碳計算": "Carbon Reduced",
    "縣市": "County (City)",
    "鄉鎮區": "Township, District",
    "地址": "Address",
    "請輸入地址(選填)": "Please enter the Address (optional)",
    "統一編號": "Tax ID Number",
    "請輸入統一編號(選填)": "Please enter the Tax ID Number (optional)",
    "學校名稱": "School Name",
    "請輸入學校名稱(選填)": "Please enter the School Name (optional)",
    "電子信箱": "Email",
    "請輸入電子信箱(選填)": "Please enter the Email (optional)",
    "更新資訊": "Update Info",
    "註銷帳號": "Delete Account",
    "專案合作單位": "Project Partnership",
    "請選擇(選填)": "Select",
    "職工編號": "Employee Number",
    "請輸入職工編號(選填)": "Employee Number",
  },
  jp: {
    "會員資料": "マイページ",
    "我的套票": "購入/予約履歴",
    "卡片資料": "卡片資料",
    "套票兌換": "チケット引き換え",
    "交易記錄": "交易記錄",
    "其他資訊": "その他の情報",
    "帳號": "アカウント番号",
    "手機號碼": "電話番号",
    "姓名": "姓名",
    "性別": "性別",
    "出生年月": "出生年月",
    "國籍": "國籍",
    "更換手機號碼": "電話番号の変更",
    "獲取驗證碼": "認証コードを受け取る",
    "手機認證碼": "携帯電話認証コード",
    "請輸入手機簡訊驗證碼": "携帯電話のSMS認証コードを入力してください",
    "確認更換手機號碼": "電話番号変更の確認",
    "舊密碼": "旧パスワード",
    "請輸入舊密碼": "旧パスワードを入力してください",
    "新密碼": "新しいパスワード",
    "請輸入新密碼": "新しいパスワードを入力してください",
    "確認密碼": "パスワード確認",
    "更改密碼": "パスワード変更",
    "登出此帳號": "このアカウントからログアウトする",
    "登出": "ログアウトする",
    "錯誤": "エラー",
    "取得會員資訊過程發生錯誤, 請稍後再試一次": "会員情報取得中にエラーが発生しました,時間をおいてから再度お試しください",
    "確定": "確定",
    "手機號碼格式錯誤": "電話番号の形式が正しくありません",
    "更換手機號碼成功，請使用新的手機號碼重新登入": "電話番号の変更に成功しました,新しい電話番号を入力して再度ログインしてください",
    "重設密碼與確認重設密碼不符合, 請確認後再試一次": "新しいパスワードと新しいパスワード(確認用)が一致しません,ご確認の上、再度お試しください",
    "重設密碼成功": "パスワードのリセットが完了しました",
    "註銷此帳號": "このアカウントを削除する",
    "申請註銷此帳號": "このアカウントの削除を申請する",
    "請注意！一旦註銷帳號，即無法再恢復帳號資料，並且您原綁定的卡片號碼未來亦無法重複於MeN Go系統上綁定使用，如有其他因素確認欲註銷帳號，請電洽客服專線由專人協助。本人已充分瞭解並同意承擔其後果，請輸入DELETE後按下送出。": "ご注意ください！アカウントを削除すると,アカウント情報を復元できなくなり,",
    "送出": "送信",
    "取消": "取消",
    "請輸入DELETE後再按下送出": "「DELETE」と入力した後、送信を押してください",
    "帳號註銷成功": "アカウントのログアウトに成功",
    "卡片交易紀錄": "カード取引履歴",
    "減碳計算": "二酸化炭素削減計算",
    "縣市": "都道府県",
    "鄉鎮區": "市区町村",
    "地址": "住所",
    "請輸入地址(選填)": "住所を入力してください(任意)",
    "統一編號": "パスポート番号",
    "請輸入統一編號(選填)": "パスポート番号を入力してください(任意)",
    "學校名稱": "学校の名前",
    "請輸入學校名稱(選填)": "学校の名前を入力してください(任意)",
    "電子信箱": "メールアドレス",
    "請輸入電子信箱(選填)": "メールアドレスを入力してください(任意)",
    "更新資訊": "情報を更新する",
    "註銷帳號": "アカウントをキャンセルする",
    "專案合作單位": "プロジェクト提携部門",
    "請選擇(選填)": "選んでください",
    "職工編號": "従業員番号",
    "請輸入職工編號(選填)": "従業員番号を入れてください",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "MemberInfo",
  i18n,
  data() {
    return {
      UserData: {},
      countryCallingCode: "",
      number: "",
      valid: false,
      issned: false,
      pincode_input: "",
      pincode: "",
      pincodeCheck: false,
      password: "",
      newPassword: "",
      newPasswordConfirm: "",
      vtiProps: {
        disabled: false,
      },
      phone: "",
      address: "",
      CUId: -1,
      taxID: "",
      unitId: "",
      school: "",
      email: "",
      gender: "",
      Citys: [],
      Towns: [],
      local: "zh_tw",
      viewphone: false,
      viewemail: false,
      SchoolCitys: [],
      IsTester: false,
      hasInvite: false,
      SMSCheckNumber: "",
    };
  },
  watch: {
    taxID(newValue, oldValue) {
      var rules = new RegExp(/[^0-9]/g);
      if (rules.test(newValue)) {
        this.$nextTick(() => {
          this.taxID = newValue.replace(rules, '');
        })
      }
    },
    unitId(newValue, oldValue) {
      var rules = new RegExp(/[^a-zA-Z0-9@_\-.\u4E00-\u9FA5]/g);
      if (rules.test(newValue)) {
        this.$nextTick(() => {
          this.unitId = newValue.replace(rules, '');
        })
      }
    },
    email(newValue, oldValue) {
      var rules = new RegExp(/[^a-zA-Z0-9@_.]/g);
      if (rules.test(newValue)) {
        this.$nextTick(() => {
          this.email = newValue.replace(rules, '');
        })
      }
    },
    viewphone(newValue, oldValue) {
      if (newValue) {
        $(".vti__input").addClass("show_phone");
      } else {
        $(".vti__input").removeClass("show_phone");
      }
    },
  },
  created: function () {
    let that = this;
    $.ajax({
      url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Member",
      //url: "https://localhost:44321/Html/OrderInfo",
      type: "post",
      data: {
        token: Storage.get("ek_login_token"),
      },
      dataType: "json",
      error: function () {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("取得會員資訊過程發生錯誤, 請稍後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      },
      success: function (res) {
        // 判斷結果
        if (res.ok) {
          that.UserData = JSON.parse(res.data);
          that.address = that.UserData.User.Address;
          that.CUId = that.UserData.User.CUId;
          that.taxID = that.UserData.User.TaxID;
          that.unitId = that.UserData.User.UnitId;
          that.school = that.UserData.User.School;
          that.email = that.UserData.User.Email;
          that.gender = that.UserData.User.Sex;
          that.Citys = that.UserData.Citys;
          that.Towns = that.UserData.Towns;
          that.SchoolCitys = that.UserData.SchoolCitys;
          that.IsTester = that.UserData.IsTester;
          that.hasInvite = that.UserData.hasInvite;
        } else if (res.error_msg) {
          var error_msg = JSON.parse(res.error_msg);
          if (res.toekn_error) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
              willClose: function () {
                // 移除登入資訊
                Storage.remove("ek_login_token");
                // 回到首頁
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              },
            });
          } else {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        }
      },
    });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-information");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  updated: function () {
    $("#selectSchool").select2();
    let that = this;
    $("#city").on("change", function () {
      var o_maas_town_city_seq = $(this).find("option:selected").val();
      $.ajax({
        type: "post",
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/GetTown",
        data: {
          o_maas_town_city_seq: o_maas_town_city_seq,
        },
        success: function (result) {
          $("#town").find("option").remove();
          var data = jQuery.parseJSON(result.items);
          $.each(data, function (i, item) {
            $("#town").append(
              '<option value="' + item.id + '">' + item.text + "</option>"
            );
          });
          $("#town").val($("#town option:first").val());
        },
      });
    });
  },
  methods: {
    onInput(phone, phoneObject, input) {
      this.countryCallingCode = phoneObject.countryCallingCode;
      this.number = phoneObject.number;
      this.valid = phoneObject.valid;
    },
    getPinCode() {
      if (!this.valid) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("手機號碼格式錯誤"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
      } else {
        let countryCallingCode =
          this.countryCallingCode == null ? "" : this.countryCallingCode;
        let number = this.number == null ? "" : this.number;
        // 組合並送出
        let token = AES.encrypt(countryCallingCode + "|" + number);
        let that = this;
        $.ajax({
          url:
            that.GLOBAL.apiSrc +
            that.GLOBAL.subDirectory +
            "/Htmlv2/MemberCheckNumber",
          type: "post",
          data: {
            token: token,
          },
          dataType: "json",
          error: function () { },
          success: function (res) {
            // 判斷結果
            if (res.ok) {
              that.vtiProps.disabled = true;
              that.issned = true;
              that.SMSCheckNumber = res.SMSCheckNumber;
            } else if (res.error_msg) {
              var error_msg = JSON.parse(res.error_msg);
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            }
          },
        });
      }
    },
    handleChangePhone() {
      if (!this.pincode_input) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("請輸入手機簡訊驗證碼"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }
      let countryCallingCode =
        this.countryCallingCode == null ? "" : this.countryCallingCode;
      let number = this.number == null ? "" : this.number;
      let token = AES.encrypt(
        this.UserData.User.Account + "|" + countryCallingCode + "|" + number + "|" + this.SMSCheckNumber + "|" + this.pincode_input
      );
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/MemberChangePhone",
        type: "post",
        data: {
          token: token,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("更換手機號碼成功，請使用新的手機號碼重新登入"),
              showConfirmButton: false,
              timer: 3000,
              didDestroy: () => {
                Storage.remove("ek_login_token");
                //location.reload();
                // 返回首頁
                location.href = "/#/Login";
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
            that.vtiProps.disabled = false;
            that.issned = false;
            that.pincode_input = "";
            that.pincodeCheck = false;
          }
        },
      });
    },
    handleChangePassword() {
      let password = this.password;
      let newPassword = this.newPassword;
      let newPasswordConfirm = this.newPasswordConfirm;
      if (newPassword != newPasswordConfirm) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("重設密碼與確認重設密碼不符合, 請確認後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }
      let token = AES.encrypt(
        this.UserData.User.Account + "|" + password + "|" + newPasswordConfirm
      );
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/MemberChangePassword",
        //url: "https://localhost:44321/Html/MemberChangePassword",
        type: "post",
        data: {
          token: token,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("重設密碼成功"),
              showConfirmButton: false,
              timer: 3000,
              didDestroy: () => {
                // // 重整頁面
                // location.reload();
                that.password = "";
                that.newPassword = "";
                that.newPasswordConfirm = "";
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
      });
    },
    handleChangeInfo() {
      if (this.email != "" && !this.validateEmail(this.email)) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("請輸入一個正確的電子郵件地址"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        this.sending = false;
        return;
      }
      let token = AES.encrypt(
        this.UserData.User.Account +
        "|" +
        $("#city").val() +
        "|" +
        $("#town").val() +
        "|" +
        this.address +
        "|" +
        this.taxID +
        "|" +
        this.school +
        "|" +
        this.email +
        "|" +
        this.gender +
        "|" +
        this.CUId +
        "|" +
        this.unitId
      );
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/MemberChangeInfo",
        type: "post",
        data: {
          token: token,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("更新資訊成功"),
              showConfirmButton: false,
              timer: 3000,
              // didDestroy: () => {
              //   // 重整頁面
              //   location.reload();
              // },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
      });
    },
    logout: function (lang) {
      let that = this;
      let ek_login_token = Storage.get("ek_login_token");
      Storage.remove("ek_login_token");
      //location.reload();
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Logout",
        type: "post",
        data: {
          token: ek_login_token,
        },
        dataType: "json",
        error: function () {
          that.$router.push("/");
        },
        success: function () {
          // 轉到首頁
          that.$router.push("/");
        },
      });
    },
    applyClear: function () {
      let that = this;
      that
        .$swal({
          heightAuto: false,
          icon: "warning",
          title: "請注意!",
          html: that.$t(
            "請注意！一旦註銷帳號，即無法再恢復帳號資料，並且您原綁定的卡片號碼未來亦無法重複於MeN Go系統上綁定使用，如有其他因素確認欲註銷帳號，請電洽客服專線由專人協助。本人已充分瞭解並同意承擔其後果，請輸入DELETE後按下送出。"
          ),
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonText: that.$t("送出"),
          cancelButtonText: that.$t("取消"),
          input: "text",
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (value != "DELETE") {
                resolve(that.$t("請輸入DELETE後再按下送出"));
              } else {
                resolve();
              }
            });
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            $.ajax({
              url:
                that.GLOBAL.apiSrc +
                that.GLOBAL.subDirectory +
                "/Htmlv2/ApplyClear",
              type: "post",
              data: {
                token: Storage.get("ek_login_token"),
              },
              dataType: "json",
              error: function () { },
              success: function (res) {
                // 判斷結果
                if (res.ok) {
                  that.$swal({
                    heightAuto: false,
                    icon: "success",
                    title: that.$t("帳號註銷成功"),
                    showConfirmButton: false,
                    timer: 3000,
                    allowOutsideClick: false,
                    didDestroy: () => {
                      Storage.remove("ek_login_token");
                      that.$router.push("/");
                    },
                  });
                } else if (res.error_msg) {
                  var error_msg = JSON.parse(res.error_msg);
                  that.$swal({
                    heightAuto: false,
                    title: that.$t("錯誤"),
                    text: error_msg[i18n.locale],
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: that.$t("確定"),
                  });
                }
              },
            });
          }
        });
    },
    validateEmail(email) {
      if (/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(email)) {
        return true;
      } else {
        return false;
      }
    },
    hideInfo(str, s, e) {
      var length = str.length;
      if (length - (s + e) > 0) {
        var hide = "";
        hide = str.substr(0, s);
        for (var i = 0; i < length - (s + e); i++) {
          hide += "*";
        }
        hide += str.substr(length - e, e);
        return hide;
      }
      else {
        for (var i = 0; i < s + e; i++) {
          hide += "*";
        }
        return hide;
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#showPhone {
  position: absolute;
  top: 25%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
}

#showEmail {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/MemberInfo.vue